import { TownsquareSiteAri } from '@atlassian/ari';

import { RelayResourceConfig, createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import ExplainerAggQuery, {
	TqlExplainerAggQuery,
} from '../components/__generated__/TqlExplainerAggQuery.graphql';

export const getTqlExplainerAggResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<TqlExplainerAggQuery> => {
	const { workspace } = resourceContext as ResourceContext;
	const { tql, viewUuid } = routerContext.query;
	const cloudId = workspace?.cloudId;
	const containerId = cloudId ? TownsquareSiteAri.create({ siteId: cloudId }).toString() : null;
	const hasTqlOrViewUuid = (!!tql || !!viewUuid) && !!containerId;

	return {
		environment: getAggRelayEnvironment(),
		query: ExplainerAggQuery,
		variables: {
			searchString: tql,
			directoryViewId: viewUuid,
			containerId: containerId ?? '',
			hasTqlOrViewUuid,
		},
		options: {
			fetchPolicy: 'store-and-network',
		},
	};
};

export const tqlExplainerAggResource = createRelayResource<TqlExplainerAggQuery>({
	getQuery: getTqlExplainerAggResourceQuery,
});
